import clsx from 'clsx'
import { ReactNode } from 'react'

type Props = {
  title: ReactNode // Represents the author, e.g., "You"
  children: ReactNode // The main comment text
  time: string // e.g., "8:33 pm"
  selected?: boolean
  onClick?: () => void
  menu?: ReactNode // Replaced onEdit and onDelete with a generic menu prop
}
export function CommentCard({
  title,
  selected = false,
  time,
  children,
  onClick,
  menu // Use the menu prop
}: Props) {
  return (
    <div
      className={clsx(
        'group relative cursor-pointer rounded-sm border-l-4 bg-white p-3 shadow-sm transition-colors',
        selected ? 'border-blue-500' : 'border-transparent'
      )}
      onClick={onClick}
    >
      <div className="mb-2 flex flex-row">
        <span className="w-1/2 overflow-hidden text-ellipsis whitespace-nowrap pr-2 text-sm font-semibold text-black">
          {title}
        </span>
        <span className="w-1/2 overflow-hidden text-ellipsis whitespace-nowrap pl-2 text-right text-sm text-gray-500">
          {time}
        </span>
      </div>

      <div className="whitespace-pre-wrap break-words text-base text-gray-800">{children}</div>

      {menu && <div className="absolute bottom-1 right-1">{menu}</div>}
    </div>
  )
}
